import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import IntensiveEnglishRoute from "./English";
import IntensiveEnglishV2Route from "./EnglishV2";

export const IntensiveRoutes = () => (
  <Routes>
    <Route path="/intensive-english" element={<IntensiveEnglishRoute />} />
    <Route path="/intensive-english-v2" element={<IntensiveEnglishV2Route />} />
    <Route path="*" element={<Navigate to="/intensive-english" />} />
  </Routes>
);
